module.exports = __webpack_public_path__ + "static/jumbotron-8ba6a7b94214f7418b8d9ea8fd7b4dec.jpg";